import BaseScenarioPart from "../../../../cvp-webgames-core/Scenario/BaseScenarioPart";
import { getNextPartId } from "../../../../misc/tools";
import { BaseGeneralConfig, GameBaseScenario, GeneralPartConfig } from "../../../GameBaseScenario";
import BufferInMriComponentsStep0Part1 from "./buffer-in-mri-components-step0-parts/buffer-in-mri-components-step0-part1";

export default class BufferInMriComponentsStep0Component {
	private _parts: BaseScenarioPart<GameBaseScenario>[] = [];
	private _partId1 = getNextPartId();
	public get parts() {
		return this._parts;
	}
	constructor(public config: BufferInMriComponentsStep0ComponentMainConfig) {
		let context = this;
		context._parts.push(new BufferInMriComponentsStep0Part1(context.config.scenario, () => {
			context.config.onDone();
		}, context._partId1, config));
	}

	public start() {
		this.goToPart1();
	}

	goToPart1() {
		this.config.scenario.loadPart(this._partId1);
	}
}

export interface BufferInMriComponentsStep0ComponentMainConfig extends BaseGeneralConfig {
	scenario: GameBaseScenario;
	part1Config?: BufferInMriComponentsStep0ComponentPart1Config;
	onDone: () => void;
}

export interface BufferInMriComponentsStep0ComponentPart1Config extends GeneralPartConfig {
	chapter: () => string;
}